module.exports = __webpack_public_path__ + "img/harkevich.d8097f20.jpg";